/**
 * @generated SignedSource<<2e018616b929a998b6ec515ed94db348>>
 * @relayHash e9f6e078336d1be613f7821fc017ed0a
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8b45a76d75c162724c3951fc3a54c6aa4fc282c7a6fc169ab5a3d52afcbcfe5a

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type branchOverviewPageQuery$variables = {
  account: string;
  branch: string;
  from: string;
  graph: string;
  to: string;
};
export type branchOverviewPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"branchOverviewPageFragment">;
};
export type branchOverviewPageQuery = {
  response: branchOverviewPageQuery$data;
  variables: branchOverviewPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "account"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "branch"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "graph"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "to"
},
v5 = {
  "kind": "Variable",
  "name": "accountSlug",
  "variableName": "account"
},
v6 = {
  "kind": "Variable",
  "name": "graphSlug",
  "variableName": "graph"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cacheHitCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cacheMissCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cachePassCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "error4XxCount",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "error5XxCount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorGraphqlCount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latencyMsPercentiles",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v18 = [
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "branch",
    "variableName": "branch"
  },
  (v6/*: any*/),
  {
    "kind": "Literal",
    "name": "last",
    "value": 5
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "branchOverviewPageQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "branchOverviewPageFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "branchOverviewPageQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "concreteType": "Graph",
        "kind": "LinkedField",
        "name": "graphByAccountSlug",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "branchName",
                    "variableName": "branch"
                  },
                  {
                    "kind": "Variable",
                    "name": "from",
                    "variableName": "from"
                  },
                  {
                    "kind": "Variable",
                    "name": "to",
                    "variableName": "to"
                  }
                ],
                "kind": "ObjectValue",
                "name": "filters"
              }
            ],
            "concreteType": "GraphAnalytics",
            "kind": "LinkedField",
            "name": "analytics",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "latencyPercentiles",
                    "value": [
                      95,
                      99
                    ]
                  }
                ],
                "concreteType": "RequestMetricsTimeSeriesV2",
                "kind": "LinkedField",
                "name": "requestMetrics",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RequestMetricsV2",
                    "kind": "LinkedField",
                    "name": "overall",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RequestMetricsTimeSeriesDataPointV2",
                    "kind": "LinkedField",
                    "name": "points",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dateTime",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "requestMetrics(latencyPercentiles:[95,99])"
              }
            ],
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "branch"
          }
        ],
        "concreteType": "Branch",
        "kind": "LinkedField",
        "name": "branch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "environment",
            "storageKey": null
          },
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Deployment",
            "kind": "LinkedField",
            "name": "activeDeployment",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EndpointConfig",
            "kind": "LinkedField",
            "name": "endpointConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v18/*: any*/),
        "concreteType": "SchemaVersionConnection",
        "kind": "LinkedField",
        "name": "schemaVersions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SchemaVersionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SchemaVersion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Subgraph",
                    "kind": "LinkedField",
                    "name": "subgraph",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SchemaVersionDelta",
                    "kind": "LinkedField",
                    "name": "delta",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "added",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "removed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "modified",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SchemaVersionChangeConnection",
                    "kind": "LinkedField",
                    "name": "changes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SchemaVersionChange",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "path",
                            "storageKey": null
                          },
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v18/*: any*/),
        "filters": [
          "accountSlug",
          "graphSlug",
          "branch"
        ],
        "handle": "connection",
        "key": "ChangelogPageFragment_schemaVersions",
        "kind": "LinkedHandle",
        "name": "schemaVersions"
      }
    ]
  },
  "params": {
    "cacheID": "e9f6e078336d1be613f7821fc017ed0a",
    "id": "8b45a76d75c162724c3951fc3a54c6aa4fc282c7a6fc169ab5a3d52afcbcfe5a",
    "metadata": {},
    "name": "branchOverviewPageQuery",
    "operationKind": "query",
    "text": "query branchOverviewPageQuery(\n  $account: String!\n  $graph: String!\n  $branch: String!\n  $from: DateTime!\n  $to: DateTime!\n) {\n  ...branchOverviewPageFragment\n}\n\nfragment branchOverviewPageChangelogFragment_VbLdN on Query {\n  schemaVersions(accountSlug: $account, graphSlug: $graph, branch: $branch, last: 5) {\n    edges {\n      node {\n        id\n        ...changelogVersionFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment branchOverviewPageChartFragment_IyvGz on Graph {\n  analytics(filters: {branchName: $branch, from: $from, to: $to}) {\n    requestMetrics(latencyPercentiles: [95, 99]) {\n      overall {\n        cacheHitCount\n        cacheMissCount\n        cachePassCount\n        count\n        error4XxCount\n        error5XxCount\n        errorGraphqlCount\n        latencyMsPercentiles\n      }\n      points {\n        cacheHitCount\n        cacheMissCount\n        cachePassCount\n        count\n        dateTime\n        error4XxCount\n        error5XxCount\n        errorGraphqlCount\n        latencyMsPercentiles\n      }\n    }\n  }\n}\n\nfragment branchOverviewPageFragment on Query {\n  graphByAccountSlug(accountSlug: $account, graphSlug: $graph) {\n    slug\n    ...branchOverviewPageChartFragment_IyvGz\n    id\n  }\n  branch(accountSlug: $account, graphSlug: $graph, name: $branch) {\n    environment\n    name\n    activeDeployment {\n      __typename\n      id\n    }\n    endpointConfig {\n      url\n    }\n    id\n  }\n  ...branchOverviewPageChangelogFragment_VbLdN\n}\n\nfragment changelogVersionChangesFragment on SchemaVersion {\n  changes {\n    nodes {\n      type\n      path\n      message\n    }\n  }\n}\n\nfragment changelogVersionFragment on SchemaVersion {\n  id\n  message\n  createdAt\n  subgraph {\n    name\n  }\n  delta {\n    added\n    removed\n    modified\n  }\n  ...changelogVersionChangesFragment\n}\n"
  }
};
})();

(node as any).hash = "63c4521cb9da394eb08ae0f7ea147fc8";

export default node;
